export const LOAD = 'auth/LOAD';
export const LOGOUT = 'auth/LOGOUT';
export const INITIALIZE = 'auth/INITIALIZE';
export const UPDATE_CURRENT_USER = 'auth/UPDATE_CURRENT_USER';



// WEBPACK FOOTER //
// ./app/modules/auth/action-types.js